import { ReactElement, useEffect } from "react";
import { Anchor, Container, Loader, Text } from "@mantine/core";
import { purchasesStore } from "@stores/purchases";
import { isDevPlan, isSelfHostedPlan } from "@common/utils/plan";
import ErrorMessage from "@common/components/text/ErrorMessage";
import Link from "next/link";
import { useRouter } from "next/router";
import { persistUTMQueryParamsToUrlObject } from "@common/utils/router";
import { STATUS_RUNNING } from "@stores/instances/constants";
import {
  SUBSCRIPTION_STATUS_ACTIVE,
  SUBSCRIPTION_STATUS_TRIAL,
} from "@stores/subscriptions/constants";
import PageTitle from "@common/components/thirdParty/mantine/text/PageTitle";

export default function StoragePage(): ReactElement {
  const router = useRouter();

  const {
    isLoading: loadingPurchases,
    error: purchasesError,
    data: purchases = [],
  } = purchasesStore.useGetPurchases();

  const [purchase] = purchases?.filter(
    ({ hosted_instance, product, subscription }) =>
      hosted_instance?.status === STATUS_RUNNING &&
      !isSelfHostedPlan(product.plan.alias) &&
      !isDevPlan(product.plan.alias) &&
      (subscription.status === SUBSCRIPTION_STATUS_ACTIVE ||
        subscription.status === SUBSCRIPTION_STATUS_TRIAL),
  );

  // redirect to the first eligible purchase
  useEffect(() => {
    if (purchase) {
      router.push(
        persistUTMQueryParamsToUrlObject(
          router,
          `/account/${purchase.id}/storage`,
        ),
      );
    }
  }, [router, purchase]);

  return (
    <Container>
      {loadingPurchases && <Loader />}

      <ErrorMessage error={purchasesError} />

      {!loadingPurchases &&
        !purchasesError &&
        (!purchases.length || !purchase) && (
          <>
            <PageTitle>Storage</PageTitle>
            <Text fz="sm">
              <b>No available purchase</b>, please check your instances{" "}
              <Anchor component={Link} href="/account">
                here
              </Anchor>
              .
            </Text>
          </>
        )}
    </Container>
  );
}
